import {i18n} from "@/plugins/i18n";

export const walletSettingStatus = {
    DISABLE: 0,
    ENABLE: 1,
};

export const walletSettingStatusStr = {
    DISABLE: i18n.t('label.inactive'),
    ENABLE: i18n.t('label.active'),

    get(status) {
        let status_str = null;

        Object.keys(walletSettingStatus).forEach(item => {
            if (walletSettingStatus[item] === status) {
                status_str = walletSettingStatusStr[item];
            }
        });

        return status_str;
    }
};
